module.exports = __webpack_public_path__ + "static/img/32-2x.d825da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/32-2x.png
// module id = HPWD
// module chunks = 1